import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { StoreService } from '../../services/store.service';

let __message_shown = false;

@Component({
  selector: 'app-header-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  message;
  closeTime;

  constructor(private store: StoreService) {
    this.message = this.store.userMessage;

    try {
      this.closeTime = new Date(JSON.parse(localStorage.getItem('notification_hide_timeout')));
      if (!this.closeTime.isValid())
        throw 'invalid';
    } catch (e) {
      let d = new Date();
      d.setDate(d.getDate() - 1);
      this.closeTime = d;
    }

    let d = new Date();
    d.setMinutes( d.getMinutes() - 30 );

    if (this.closeTime < d) {
      __message_shown = true;
    }

  }

  ngOnInit(): void {
  }

  isShown() {
    return __message_shown;
  }

  hide() {
    this.closeTime = new Date();
    localStorage.setItem('notification_hide_timeout', JSON.stringify(this.closeTime));
    __message_shown = false;
  }

}
